import React from 'react';
import { Image, ImageProps } from 'semantic-ui-react';
import {
  PosAnimatedImageNames,
  PosAnimatedImagesId,
} from '../../enums/PosAnimatedImageNames';
import ExpertBlack from '../../assets/animatedImages/Expert-Black.png';
import ExpertBlackDelay from '../../assets/animatedImages/Expert-Black-Delay.png';
import ExpertWhite from '../../assets/animatedImages/Expert-White.png';
import ExpertWhiteDelay from '../../assets/animatedImages/Expert-White-Delay.png';
import GeneratingBlack from '../../assets/animatedImages/Generating-Black.png';
import GeneratingBlackDelay from '../../assets/animatedImages/Generate-Black-Delay.png';
import GeneratingWhite from '../../assets/animatedImages/Generating-White.png';
import GeneratingWhiteDelay from '../../assets/animatedImages/Generate-White-Delay.png';
import HelloBlack from '../../assets/animatedImages/Hello-Black.png';
import HelloBlackDelay from '../../assets/animatedImages/Hello-Black-Delay.png';
import HelloWhite from '../../assets/animatedImages/Hello-White.png';
import HelloWhiteDelay from '../../assets/animatedImages/Hello-White-Delay.png';
import HelpBlack from '../../assets/animatedImages/Help-Black.png';
import HelpBlackDelay from '../../assets/animatedImages/Help-Black-Delay.png';
import HelpWhite from '../../assets/animatedImages/Help-White.png';
import HelpWhiteDelay from '../../assets/animatedImages/Help-White-Delay.png';
import IdleBlack from '../../assets/animatedImages/Idle-Black.png';
import IdleBlackDelay from '../../assets/animatedImages/Idle-Black-Delay.png';
import IdleWhite from '../../assets/animatedImages/Idle-White.png';
import IdleWhiteDelay from '../../assets/animatedImages/Idle-White-Delay.png';
import LoadingBlack from '../../assets/animatedImages/Loading-Black.png';
import LoadingBlackDelay from '../../assets/animatedImages/Loading-Black-Delay.png';
import LoadingWhite from '../../assets/animatedImages/Loading-White.png';
import LoadingWhiteDelay from '../../assets/animatedImages/Loading-White-Delay.png';
import NegativeBlack from '../../assets/animatedImages/Negative-Black.png';
import NegativeBlackDelay from '../../assets/animatedImages/Negative-Black-Delay.png';
import NegativeWhite from '../../assets/animatedImages/Negative-White.png';
import NegativeWhiteDelay from '../../assets/animatedImages/Negative-White-Delay.png';
import PositiveBlack from '../../assets/animatedImages/Positive-Black.png';
import PositiveBlackDelay from '../../assets/animatedImages/Positive-Black-Delay.png';
import PositiveWhite from '../../assets/animatedImages/Positive-White.png';
import PositiveWhiteDelay from '../../assets/animatedImages/Positive-White-Delay.png';
import KonnectSymbol from '../../assets/animatedImages/Konnect-Symbol.svg';
export interface Props extends ImageProps {
  image?: PosAnimatedImagesId;
}

export const POSAnimatedImage = (props: Props) => {
  const image = props.image ? PosAnimatedImageNames[props.image] : '';
  let imageSrc;

  switch (image) {
    case 'Expert-Black':
      imageSrc = ExpertBlack;
      break;
    case 'Expert-Black-Delay':
      imageSrc = ExpertBlackDelay;
      break;
    case 'Expert-White':
      imageSrc = ExpertWhite;
      break;
    case 'Expert-White-Delay':
      imageSrc = ExpertWhiteDelay;
      break;
    case 'Generating-Black':
      imageSrc = GeneratingBlack;
      break;
    case 'Generating-Black-Delay':
      imageSrc = GeneratingBlackDelay;
      break;
    case 'Generating-White':
      imageSrc = GeneratingWhite;
      break;
    case 'Generating-White-Delay':
      imageSrc = GeneratingWhiteDelay;
      break;
    case 'Hello-Black':
      imageSrc = HelloBlack;
      break;
    case 'Hello-Black-Delay':
      imageSrc = HelloBlackDelay;
      break;
    case 'Hello-White':
      imageSrc = HelloWhite;
      break;
    case 'Hello-White-Delay':
      imageSrc = HelloWhiteDelay;
      break;
    case 'Help-Black':
      imageSrc = HelpBlack;
      break;
    case 'Help-Black-Delay':
      imageSrc = HelpBlackDelay;
      break;
    case 'Help-White':
      imageSrc = HelpWhite;
      break;
    case 'Help-White-Delay':
      imageSrc = HelpWhiteDelay;
      break;
    case 'Idle-Black':
      imageSrc = IdleBlack;
      break;
    case 'Idle-Black-Delay':
      imageSrc = IdleBlackDelay;
      break;
    case 'Idle-White':
      imageSrc = IdleWhite;
      break;
    case 'Idle-White-Delay':
      imageSrc = IdleWhiteDelay;
      break;
    case 'Loading-Black':
      imageSrc = LoadingBlack;
      break;
    case 'Loading-Black-Delay':
      imageSrc = LoadingBlackDelay;
      break;
    case 'Loading-White':
      imageSrc = LoadingWhite;
      break;
    case 'Loading-White-Delay':
      imageSrc = LoadingWhiteDelay;
      break;
    case 'Negative-Black':
      imageSrc = NegativeBlack;
      break;
    case 'Negative-Black-Delay':
      imageSrc = NegativeBlackDelay;
      break;
    case 'Negative-White':
      imageSrc = NegativeWhite;
      break;
    case 'Negative-White-Delay':
      imageSrc = NegativeWhiteDelay;
      break;
    case 'Positive-Black':
      imageSrc = PositiveBlack;
      break;
    case 'Positive-Black-Delay':
      imageSrc = PositiveBlackDelay;
      break;
    case 'Positive-White':
      imageSrc = PositiveWhite;
      break;
    case 'Positive-White-Delay':
      imageSrc = PositiveWhiteDelay;
      break;
    case 'Konnect-Symbol':
      imageSrc = KonnectSymbol;
      break;
    default:
      imageSrc = LoadingBlack;
      break;
  }
  return <Image src={imageSrc} {...props} />;
};
